"use client";

import { usePrefersReducedMotion } from "@ui/hooks/use-prefers-reduced-motion";
import { createContext, use, useMemo } from "react";
import { type SheetMotion, sheetMotion } from "./motion";

/**
 * Forces motion settings for a subtree, overriding the live
 * `prefers-reduced-motion` reading. The story runner sets `{ skip: true }` so
 * teardown never races a running animation (Silk touches removed DOM when a
 * story unmounts mid-travel); nothing in the app sets it.
 */
export const SheetMotionOverride = createContext<{ skip?: boolean } | null>(null);

/** House sheet motion for the current user preference. */
export function useSheetMotion(): SheetMotion {
  const reducedMotion = usePrefersReducedMotion();
  const override = use(SheetMotionOverride);
  return useMemo(() => sheetMotion(reducedMotion, override), [reducedMotion, override]);
}
